module.exports = __webpack_public_path__ + "img/map-allegiant-stadium.1e751a79.png";